/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Forwarder, ForwarderInterface } from "../Forwarder";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "assetStorage",
    outputs: [
      {
        components: [
          {
            internalType: "contract IShareToken",
            name: "collateralToken",
            type: "address",
          },
          {
            internalType: "contract IShareToken",
            name: "collateralOnlyToken",
            type: "address",
          },
          {
            internalType: "contract IShareToken",
            name: "debtToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "totalDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "collateralOnlyDeposits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalBorrowAmount",
            type: "uint256",
          },
        ],
        internalType: "struct IBaseSilo.AssetStorage",
        name: "siloAssetStorage",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "debtToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "repayFor",
    outputs: [
      {
        internalType: "uint256",
        name: "repaidAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "burnedShare",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_debtToken",
        type: "address",
      },
    ],
    name: "setDebtToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IFlashLiquidationReceiver",
        name: "_destination",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_assets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_receivedCollaterals",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "_shareAmountsToRepaid",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "_flashReceiverData",
        type: "bytes",
      },
    ],
    name: "siloLiquidationCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type ForwarderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ForwarderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Forwarder__factory extends ContractFactory {
  constructor(...args: ForwarderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Forwarder";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Forwarder> {
    return super.deploy(overrides || {}) as Promise<Forwarder>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Forwarder {
    return super.attach(address) as Forwarder;
  }
  connect(signer: Signer): Forwarder__factory {
    return super.connect(signer) as Forwarder__factory;
  }
  static readonly contractName: "Forwarder";
  public readonly contractName: "Forwarder";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ForwarderInterface {
    return new utils.Interface(_abi) as ForwarderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Forwarder {
    return new Contract(address, _abi, signerOrProvider) as Forwarder;
  }
}
